import React from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

const Breadcrumb = ({ items }) => {
  return (
    <ul className="breadcrumb">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <li className="breadcrumb-item">
            {item.path ? (
              <Link to={item.path}>{item.label}</Link>
            ) : (
              <span>{item.label}</span>
            )}
          </li>
          {index < items.length - 1 && (
            <li className="breadcrumb-item">
              <FeatherIcon icon="chevron-right" size={16} />
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default Breadcrumb;